/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "lazysizes";

export function onServiceWorkerUpdateReady(){window.location.reload(true)};

// Tawk.to chat widget, lazy-loaded (was gatsby-plugin-tawk, which injected it
// into the critical path on every page). Loads on the first user interaction,
// or 5 seconds after the page finishes loading — whichever comes first. The
// only visible difference is the chat bubble appearing a few seconds later.
const TAWK_ID = "5f6bf102f0e7167d001338fa";
const tawkEvents = ["scroll", "mousemove", "touchstart", "click"];
let tawkLoaded = false;
function loadTawk() {
  if (tawkLoaded) return;
  tawkLoaded = true;
  tawkEvents.forEach((e) => window.removeEventListener(e, loadTawk));
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://embed.tawk.to/${TAWK_ID}/default`;
  s.charset = "UTF-8";
  s.setAttribute("crossorigin", "*");
  document.head.appendChild(s);
}
export const onInitialClientRender = () => {
  tawkEvents.forEach((e) =>
    window.addEventListener(e, loadTawk, { passive: true })
  );
  const armFallback = () => setTimeout(loadTawk, 5000);
  if (document.readyState === "complete") armFallback();
  else window.addEventListener("load", armFallback, { once: true });
};
